export default __webpack_public_path__ + "static/media/overlay.63fd7c93.png";